import { render } from "./CardPolicy.vue?vue&type=template&id=bbd0277e&scoped=true"
import script from "./CardPolicy.vue?vue&type=script&lang=js"
export * from "./CardPolicy.vue?vue&type=script&lang=js"

import "./CardPolicy.vue?vue&type=style&index=0&id=bbd0277e&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbd0277e"]])

export default __exports__